import React, { useState, useEffect } from "react";
import { Stepper, Step, StepLabel, Container, Input, useEventCallback } from '@mui/material';

import { Link } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import swal from 'sweetalert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import { useLocation } from 'react-router-dom';
import { Radio, RadioGroup, FormLabel } from '@mui/material';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { pink } from '@mui/material/colors';



import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useRef } from 'react';
import _isEqual from 'lodash/isEqual';

function createData(
    id,
    coupon_code,
    workshop_id,
    disount,



) {
    return { id, coupon_code, workshop_id, disount, };
}



const rowssss = [
    createData(1, '123', 6),
    createData(1, 'kfsRY7IRI'),
    createData(2, 'micSSQ4CA'),
    createData(3, '789', 5),
    createData(4, '963', 7),
    createData(5, '258', 25),
    createData(6, '147', 26),



].sort((a, b) => (a.SubmitStatus < b.SubmitStatus ? -1 : 1));

// const coupons = [
//     { id: 1, code: '123', workshop_id: 6 },
//     { id: 2, code: 'kfsRY7IRcI', workshop_id: 6 },
//     { id: 3, code: 'micSSQ4CA', workshop_id: 28 },
//     { id: 4, code: 'fixFDMJIK', workshop_id: 5 },
//     { id: 5, code: '963', workshop_id: 7 },
//     { id: 6, code: '258', workshop_id: 25 },
//     { id: 7, code: '147', workshop_id: 26 },
// ];

// const rows = [
//     createData(1, '123', 6),
//     createData(1, 'kfsRY7IRI'),
//     createData(2, 'micSSQ4CA'),
//     createData(3, 'fixFDMJIK', 5),
//     createData(4, '963', 7),
//     createData(5, '258', 25),
//     createData(6, '147', 26),
// ].map((row, index) => {
//     const coupon = coupons.find((coupon) => coupon.code === row.couponCode);
//     const discount = coupon ? coupon.discount : 0;
//     return { ...row, discount };
// }).sort((a, b) => (a.SubmitStatus < b.SubmitStatus ? -1 : 1));

const steps = ['Step 1', 'Step 2', 'Step 3']; // Define your steps
const EditConferenceParticpant = (props) => {
    const id = props.match.params.id;

    const gradientBackground = '#05597D';
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const isMediumScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const cardStyles = {
        width: isSmallScreen ? '85vw' : isMediumScreen ? '80vw' : '60vw',
        margin: 'auto',
    };



    const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
    const [activeStep, setActiveStep] = useState(0);
    const [formData, setFormData] = useState({
        // Initialize form data here
        firstName: '',
        lastName: '',
        email: '',
    });
    const history = useHistory();
    const [disabled, setdisabled] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isChecked, setChecked] = useState(false);
    const eventName = localStorage.getItem('eventname');
    const eventid = localStorage.getItem('eventid');
    const [nameTitle, setNameTitle] = useState('');
    const [gender, setGender] = useState(''); // state to hold the selected value
    const [country, setCountry] = useState('');
    const [registrationType, setRegistrationType] = useState('');
    const [assignModule, setassignModules] = useState([]);
    const [checkmodules, setCheckedmodules] = useState([]);
    const [workshopCategoryData, setWorkShopCategoryData] = useState([]);
    const [singleWorkShopCategory, setSingleWorkShopCategory] = useState('');
    const [selectedWorkshops, setSelectedWorkshops] = useState([]);
    const [selectedWorkshopAmounts, setSelectedWorkshopAmounts] = useState([]);
    const [discountMessages, setDiscountMessages] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [disabledInputs, setDisabledInputs] = useState({});
    const [showCouponInputs, setShowCouponInputs] = useState({});
    const [workshopUsedCoupeon, setWorkshopUsedCoupeon] = useState([]);
    const tableCellRef = useRef(null);
    const [isCopied, setIsCopied] = useState(false);
    const [copiedStates, setCopiedStates] = useState({});
    const [workshopTotalSeatCount, setWorkshopTotalSeatCount] = useState();
    const workshop_particpant_email = localStorage.getItem('workshop_particpant_email');
    const [abstractHomeSetup, setAbstractHomeSetup] = useState({
        color_code: "",
        color_code_two: "",
        color_code_three: "",
        call_emergency: "",
        send_email: "",
        event_place: "",
        facebook_link: "",
        Instagram_link: "",
        linkedin_link: "",
        twitter_link: "",
        abstractFooterImage: "",
        abstractBannerImage: "",
        workshopBannerImage: "",
        abstractSponserLogos: "",
        event_name: "",
        online_status: "",
        bank_status: "",
        cash_status: "",
        free_status: "",
        error_list: [],
    });
    React.useEffect(() => {
        axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
            if (res.status === 200) {
                const getHomePageData = res.data.HomePageSetup;
                setAbstractHomeSetup(getHomePageData);
            }
        })

    }, [eventid]);
    const [addWorkShopParticpant, setAddWorkShopParticpant] = React.useState({
        workShop_partecpant_name: "",
        instituteWorkPlace: "",
        city: "",
        phone: "",
        particent_email: "",
        saudiCouncilno: "",
        price: "",
        profession: "",
        // password: "",
        // phone: "",
        // date: "",
        // address: "",
        // details: "",
        error_list: [],
    });
    const [editWorkShopParticpant, setEditWorkShopParticpant] = React.useState({

        category_amount: "",
        is_active: "",
        name_title: "",
        participant_address: "",
        participant_city: "",
        participant_country: "",
        participant_email: "",
        participant_gender: "",
        participant_name: "",
        participant_phone_number: "",
        particent_profession: "",
        participant_saudi_council_no: "",
        participant_workshop_categoy_id: "",
        password: "",
        error_list: [],
    });
    const [editWorkShopParticpantWorkshops, setEditWorkShopParticpantWorkshops] = React.useState({
        categoy_id: "",
        workshop_amount: "",
        workshop_code: "",
        workshop_discount: "",
        workshop_id: "",
        workshop_name: "",
        workshop_participant_id: "",
        workshop_type: "",
        workshop_coupon: "",
        workshop_url: "",
        workshop_start_time: "",
        workshop_date: "",
        payment_status: "",


    });
    const [updateWorkShopParticpantWorkshops, setupdateWorkShopParticpantWorkshops] = React.useState({

        // categoy_id: "",
        // workshop_amount: "",
        // workshop_code: "",
        // workshop_discount: "",
        // workshop_id: "",
        // workshop_name: "",
        // workshop_participant_id: "",
        // workshop_type: "",
        // workshop_coupon: "",
        // workshop_url: "",
        // workshop_start_time: "",
        // workshop_date: "",
        // payment_status: "",

    });





    useEffect(() => {
        const fetchParticipantData = async () => {
            try {
                const res = await axios.get(`api/conference-participant-edit/${id}`);
                if (res.status === 200) {
                    const { participant, conferences, payment } = res.data.data;
                    const selectedRegistrationType = participant.conference_category_id;

                    setEditWorkShopParticpant(participant);
                    setNameTitle(participant.name_title);
                    setGender(participant.participant_gender);
                    setCountry(participant.participant_country);

                    const conferenceData = conferences.map(conference => {
                        const confDetails = conference.conference;

                        return {
                            categoy_id: confDetails.conference_category_id,
                            conference_id: confDetails.id,
                            conference_amount: confDetails.conference_amount,
                            conference_coupon: confDetails.conference_coupon,
                            conference_day: confDetails.conference_day,
                            conference_name: confDetails.conference_name,
                            conference_discount_amount: confDetails.conference_discount_amount,
                        };
                    });

                    setEditWorkShopParticpantWorkshops(conferenceData);
                    setupdateWorkShopParticpantWorkshops(conferenceData);


                    const response = await axios.get(`api/conference-category-front-single/${selectedRegistrationType}`);
                    //console.log(response.data.totalSeatCount)

                    if (response.status === 200) {
                        setSingleWorkShopCategory(response.data.swsd);
                        // const totalSeatCounts = conferences.map(conference => conference.conference_no_ofseats);
                        //setWorkshopTotalSeatCount(response.data.totalSeatCount);
                        setWorkshopTotalSeatCount(response.data.totalSeatCount);
                        setEditWorkShopParticpant(prevState => ({
                            ...prevState,
                            conference_category_id: selectedRegistrationType,
                        }));
                    } else {
                        swal('Error', 'Check API Something Wrong', 'error');
                    }
                } else {
                    swal('Error', 'Check API Something Wrong', 'error');
                }
            } catch (error) {
                console.error('Error fetching participant data:', error);
                swal('Error', 'Failed to fetch participant data', 'error');
            }
        };

        fetchParticipantData();
    }, [id]);

    // console.log("singleWorkShopCategory" ,singleWorkShopCategory)
    //console.log("singleWorkShopCategory", singleWorkShopCategory)

    // console.log("editWorkShopParticpantWorkshops", editWorkShopParticpantWorkshops)


    useEffect(() => {
        axios.get(`api/conference-category-front-index?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const wcategoryData = res.data.conferenceCategories;
                setWorkShopCategoryData(wcategoryData);


            }
            else {
                swal('Error', "Check API Something Wrong", 'error');

            }


        });

    }, []);

    useEffect(() => {
        axios.get(`api/conference-participant-used-coupeons?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const usedCoupen = res.data.usedCoupons;

                setWorkshopUsedCoupeon(usedCoupen);
            }
            else {
                swal('Error', "Check API Something Wrong", 'error');

            }


        });

    }, []);
    const [colorMap, setColorMap] = useState({});

    //console.log("editWorkShopParticpantWorkshops" ,editWorkShopParticpantWorkshops)

    // const handleCheckboxChange = (event, workshop, workshop_amount) => {

    //     // Check if the workshop object is valid
    //     if (!workshop || typeof workshop !== 'object') {
    //         console.error('Invalid workshop object:', workshop);
    //         return;
    //     }

    //     const { id, workshop_url, workshop_date, workshop_start_time, workshop_code, workshop_name, workshop_coupon, payment_status } = workshop;
    //     console.log("workshop" , workshop)
    //     //console.log("workshop" ,workshop);

    //     //     const { id, workshop_url, workshop_date, workshop_start_time, workshop_code, workshop_name, workshop_coupon } = workshop;

    //     // Check if the workshop is already selected
    //     const isAlreadySelected = editWorkShopParticpantWorkshops.some(
    //         (selectedWorkshop) => selectedWorkshop.workshop_id === id
    //     );

    //     // Disable all checkboxes if the current one is checked
    //     const updatedWorkshops = editWorkShopParticpantWorkshops.map((selectedWorkshop) => ({
    //         ...selectedWorkshop,
    //         isDisabled: event.target.checked,
    //     }));

    //     // If the checkbox is checked and the workshop is not already selected
    //     if (event.target.checked && !isAlreadySelected) {
    //         // Generate a unique color for the row based on specific fields
    //         const uniqueColor = getColorForFields(workshop_url, workshop_date, workshop_start_time);

    //         setEditWorkShopParticpantWorkshops((prevWorkshops) => [
    //             ...prevWorkshops,
    //             {
    //                 categoy_id: workshop.categoy_id,
    //                 workshop_amount,
    //                 payment_status,
    //                 workshop_code,
    //                 workshop_discount: workshop.workshop_discount,
    //                 workshop_id: workshop.id,
    //                 workshop_name,
    //                 workshop_participant_id: workshop.workshop_participant_id,
    //                 workshop_type: workshop.workshop_type,
    //                 workshop_type: workshop.workshop_type,
    //                 workshop_coupon: workshop.workshop_coupon,
    //                 isDisabled: false, // Enable the current workshop checkbox
    //             },
    //         ]);

    //         //setSelectedWorkshopAmounts([...editWorkShopParticpantWorkshops, { id, workshop_code, workshop_amount, workshop_name, workshop_coupon ,payment_status }]);
    //         setSelectedWorkshopAmounts([...selectedWorkshopAmounts, { id, workshop_code, workshop_amount, workshop_name, workshop_coupon, payment_status }]);

    //         // Update the color map with the unique color for the specific row values
    //         setColorMap((prevColorMap) => ({
    //             ...prevColorMap,
    //             [`${workshop_url}-${workshop_date}-${workshop_start_time}`]: uniqueColor,
    //         }));
    //     } else if (!event.target.checked && isAlreadySelected) {
    //         // If the checkbox is unchecked and the workshop is already selected
    //         setEditWorkShopParticpantWorkshops((prevWorkshops) =>
    //             updatedWorkshops.filter((w) => w.workshop_id !== id)
    //         );
    //         setSelectedWorkshopAmounts(selectedWorkshopAmounts.filter((item) => item.id !== id));
    //         // Clear the color map entry when the row is unchecked
    //         setColorMap((prevColorMap) => {
    //             const newColorMap = { ...prevColorMap };
    //             delete newColorMap[`${workshop_url}-${workshop_date}-${workshop_start_time}`];
    //             return newColorMap;
    //         });
    //     } else {
    //         // If the checkbox is unchecked and the workshop is not already selected
    //         setEditWorkShopParticpantWorkshops(updatedWorkshops);
    //     }



    // };

    const handleCheckboxChange = (event, workshop) => {


        // Check if the workshop object is valid
        if (!workshop || typeof workshop !== 'object') {
            console.error('Invalid workshop object:', workshop);
            return;
        }

        // Extract necessary fields from the workshop object
        const {
            id,
            conference_amount,
            conference_category_id,
            conference_coupon,
            conference_date,
            conference_day,
            conference_discount_amount,
            conference_end_time,
            conference_name,
            conference_no_ofseats,
            conference_start_time,
            conferencecategory,
            created_at,
            created_by,
            event_id,
            event_name,
            status,
            updated_at
        } = workshop;

        // Check if the workshop is already selected
        const isAlreadySelected = editWorkShopParticpantWorkshops.some(
            (selectedWorkshop) => selectedWorkshop.conference_id === id
        );

        // Handle the checkbox change
        if (event.target.checked && !isAlreadySelected) {
            // Generate a unique color for the row based on specific fields
            const uniqueColor = getColorForFields(conference_date, conference_start_time);

            // Update the state with the new workshop
            setEditWorkShopParticpantWorkshops((prevWorkshops) => [
                ...prevWorkshops,
                {
                    conference_id: id,
                    conference_amount,
                    conference_category_id,
                    conference_coupon,
                    conference_date,
                    conference_day,
                    conference_discount_amount,
                    conference_end_time,
                    conference_name,
                    conference_no_ofseats,
                    conference_start_time,
                    conferencecategory,
                    created_at,
                    created_by,
                    event_id,
                    event_name,
                    status,
                    updated_at,
                    isDisabled: false, // Enable the current workshop checkbox
                },
            ]);

            // Add the workshop amount to the selected workshop amounts
            setSelectedWorkshopAmounts((prevAmounts) => [
                ...prevAmounts,
                {
                    id,
                    conference_amount,
                    conference_coupon,
                    conference_date,
                    conference_day,
                    conference_discount_amount,
                    conference_end_time,
                    conference_name,
                    conference_no_ofseats,
                    conference_start_time,
                    conferencecategory,
                    created_at,
                    created_by,
                    event_id,
                    event_name,
                    status,
                    updated_at,
                },
            ]);

            // Update the color map with the unique color for the specific row values
            setColorMap((prevColorMap) => ({
                ...prevColorMap,
                [`${conference_day}-${conference_date}-${conference_start_time}`]: uniqueColor,
            }));
        } else if (!event.target.checked && isAlreadySelected) {
            // Remove the workshop from the list of selected workshops
            setEditWorkShopParticpantWorkshops((prevWorkshops) =>
                prevWorkshops.filter((selectedWorkshop) => selectedWorkshop.conference_id !== id)
            );

            // Remove the workshop amount from the selected workshop amounts
            setSelectedWorkshopAmounts((prevAmounts) =>
                prevAmounts.filter((item) => item.id !== id)
            );

            // Clear the color map entry when the row is unchecked
            // setColorMap((prevColorMap) => {
            //     const newColorMap = { ...prevColorMap };
            //     delete newColorMap[`${conference_date}-${conference_start_time}`];
            //     return newColorMap;
            // });
            setColorMap((prevColorMap) => {
                const newColorMap = { ...prevColorMap };
                delete newColorMap[`${conference_day}-${conference_date}-${conference_start_time}`]; // Updated to match the key
                return newColorMap;
            });
        }
    };



    useEffect(() => {
        if (!Array.isArray(editWorkShopParticpantWorkshops)) return;

        // Check if there are any workshops with payment_status === 1
        const hasUnpaidWorkshops = editWorkShopParticpantWorkshops.some(
            workshop => workshop.payment_status !== 1
        );

        // If there are unpaid workshops, update selectedWorkshopAmounts
        if (hasUnpaidWorkshops) {
            setSelectedWorkshopAmounts(
                editWorkShopParticpantWorkshops
                    .filter(workshop => workshop.payment_status !== 1)
                    .map(({ conference_id, conference_day, conference_amount, conference_name, conference_coupon }) => ({
                        id: conference_id,
                        conference_day,
                        conference_amount,
                        conference_name,
                        conference_coupon,
                    }))
            );
        } else {
            // If there are no unpaid workshops, clear selectedWorkshopAmounts
            setSelectedWorkshopAmounts([]);
        }


    }, [editWorkShopParticpantWorkshops]);


    console.log("editWorkShopParticpantWorkshops", editWorkShopParticpantWorkshops)
    console.log("selectedWorkshopAmounts", selectedWorkshopAmounts)

    const handleregistration = (e) => {
        const selectedRegistrationType = e.target.value;

        // Trigger API request with the selectedRegistrationType
        axios.get(`api/conference-category-front-single/${selectedRegistrationType}`)
            .then((res) => {
                if (res.status === 200) {
                    const singleWorkShopData = res.data.swsd;
                    setSingleWorkShopCategory(singleWorkShopData);


                    // Update the state with the selected registration type
                    setEditWorkShopParticpant(prevState => ({
                        ...prevState,
                        conference_category_id: selectedRegistrationType,
                    }));
                } else {
                    swal('Error', 'Check API Something Wrong', 'error');
                }
            })
            .catch((error) => {
                console.error('API Error:', error);
                swal('Error', 'An error occurred while fetching data from the API', 'error');
            });
    };

    const [inputValues, setInputValues] = useState({}); // Use an object to store coupon codes for each workshop


    const handleCouponCodeChange = (workshopId, enteredCode) => {
        //console.log(`Updating coupon code for workshop ${workshopId} to ${enteredCode}`);
        setInputValues({ ...inputValues, [workshopId]: enteredCode });
    };

   
    //const couponCode = '123'; // Assuming coupon code is a string
    const [couponCodes, setCouponCodes] = useState({});

    useEffect(() => {
        axios.get(`api/conference-manage-coupon-index-front?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const wksp = res.data.conferenceCouponFront;
                setCouponCodes(wksp);
            }
            else {
                swal('Error', "Check API Something Wrong", 'error');

            }


        });

    }, []);
 

    const copyCoupon = (couponCode) => {
        navigator.clipboard
            .writeText(couponCode)
            .then(() => {
                setCopiedStates(prevState => ({ ...prevState, [couponCode]: true }));
                setTimeout(() => {
                    setCopiedStates(prevState => ({ ...prevState, [couponCode]: false }));
                }, 3000);
            })
            .catch((err) => {
                console.log(err.message);
            });
    };


    // const [colorMap, setColorMap] = useState({});








    // const isCheckboxDisabled = (workshop) => {
    //     console.log("isCheckboxDisabled" , workshop)
    //     const { id, conference_day, conference_date, conference_start_time, conference_end_time, conference_no_ofseats } = workshop;
    //     //console.log("workshop",workshop)
    //     // Check if another workshop with the same values is already selected
    //     const isDisabledz = editWorkShopParticpantWorkshops.some(
    //         (selectedWorkshop) =>
    //             selectedWorkshop.conference_day === conference_day &&
    //             selectedWorkshop.conference_date === conference_date &&
    //             selectedWorkshop.conference_start_time === conference_start_time &&
    //             selectedWorkshop.conference_end_time === conference_end_time &&
    //             selectedWorkshop.conference_id === id
    //     );


    //     // Convert workshop date and time to milliseconds since Unix epoch
    //     const workshopDateTime = new Date(`${conference_date}T${conference_start_time}`).getTime();
    //     const currentDateTime = new Date().getTime();
    //     const isTimePassed = workshopDateTime < currentDateTime;


    //     const workshopIdToMatch = workshop.id; // The workshop ID you want to match
    //     const countWorkhops = workshopTotalSeatCount?.filter(workshop => workshop.conference_id === workshopIdToMatch).length;
    //     const isSeatLimitReached = countWorkhops >= workshop.conference_no_ofseats;

    //     // Combine both conditions to determine if the checkbox should be disabled

    //     //const isDisabled = isDisabledz;
    //     const isDisabled = isDisabledz || isTimePassed || isSeatLimitReached;

    //     let seatLimitMessage = '';
    //     if (isSeatLimitReached) {
    //         seatLimitMessage = `All (2) seats are full please uncheck and proceed`;
    //         //seatLimitMessage = `Please uncheck the (2) seats that are currently full and then proceed.`;
    //     }


    //     // Check if there's a color assigned for the specific row values and use it
    //     const color = colorMap[`${conference_day}-${conference_date}-${conference_start_time}`];

    //     return { isDisabled, color, seatLimitMessage };

    // };


    const isCheckboxDisabled = (workshop) => {
        console.log("isCheckboxDisabled" , workshop)

        const {
            id,
            conference_day,
            conference_date,
            conference_end_date,
            conference_start_time,
            conference_end_time,
            conference_no_ofseats
        } = workshop;

        const isDisabledz = editWorkShopParticpantWorkshops.some(
            (selectedWorkshop) =>
                selectedWorkshop.conference_day === conference_day &&
                selectedWorkshop.conference_date === conference_date &&
                selectedWorkshop.conference_start_time === conference_start_time &&
                selectedWorkshop.conference_end_time === conference_end_time &&
                selectedWorkshop.conference_id === id
        );


        const workshopDateTime = new Date(`${conference_end_date}T${conference_start_time}`).getTime();
        const currentDateTime = new Date().getTime();
        const isTimePassed = workshopDateTime < currentDateTime;


        let timeOffMessage = "";
        if (isTimePassed) {
            timeOffMessage = `Expired`
        }
        // const countWorkhops = workshopTotalSeatCount?.filter(
        //     (workshop) => workshop?.conference_id === id
        // ).length;
        const countWorkshops = Array.isArray(workshopTotalSeatCount)
            ? workshopTotalSeatCount.filter((conference) => conference?.conference_id === id).length
            : 0;
        const isSeatLimitReached = countWorkshops >= conference_no_ofseats;
        //console.log("countWorkshops" ,countWorkshops)
        let seatLimitMessage = '';
        if (isSeatLimitReached) {
            seatLimitMessage = `All (${countWorkshops}) seats are full, please uncheck and proceed.`;
        }

        const color = colorMap[`${conference_day}-${conference_date}-${conference_start_time}`];

        // **Change 1**: The condition `!isDisabledz` ensures that if the workshop is already selected, 
        // it won't be disabled purely due to the seat limit or time passed, allowing the checkbox to be unchecked.
        const isDisabled = isTimePassed || (isSeatLimitReached && !isDisabledz);

        return { isDisabled, color, seatLimitMessage, timeOffMessage };
    };


    console.log("workshopTotalSeatCount", workshopTotalSeatCount)

    // Function to generate a unique color based on specific fields
    const getColorForFields = (conference_day, date, startTime) => {
        return `#${Math.floor(Math.random() * 16777215).toString(16)}`;
    };

    useEffect(() => {

        Object.keys(discountMessages).forEach(workshopId => {
            const message = discountMessages[workshopId];

        });
    }, [discountMessages]);

    useEffect(() => {

    }, [totalAmount]);

    const [usedCouponMessage, setUsedCouponMessage] = useState([]);
    useEffect(() => {
        Object.keys(usedCouponMessage).forEach(workshopId => {
            const message = usedCouponMessage[workshopId];

        });
    }, [usedCouponMessage]);


    useEffect(() => {
        const newTotalAmount = selectedWorkshopAmounts.reduce((acc, workshop) => {

            //acc function is is get one by one and sum 
            //const numbers = [1, 2, 3, 4, 5];
            // Output: 15 (1 + 2 + 3 + 4 + 5)
            // console.log("conference data ", workshop);

            let discount = 0;
            const singleWorkshopAmount = Number(workshop.conference_amount);

            let matchingCoupon = null;

            if (Array.isArray(couponCodes)) {
                // Remove the 'const' keyword here
                matchingCoupon = couponCodes.find(couponValue => inputValues[workshop.id] === couponValue.coupon_code);
                // Use matchingCoupon as needed
            }


            const useCoupon = workshopUsedCoupeon.filter(couponsVal => inputValues[workshop.id] === couponsVal.coupon_code);
            const useCouponCheck = workshopUsedCoupeon.find(couponsVal => inputValues[workshop.id] === couponsVal.coupon_code);
            if (matchingCoupon) {
                if (matchingCoupon.coupon_amout_type === "percentage" && workshop.id === matchingCoupon.conference_id
                    &&
                    inputValues[workshop.id] === matchingCoupon.coupon_code) {

                    if (useCouponCheck) {
                        const particpent_id = id;
                        const getPArticipentId = useCouponCheck.participant_id;

                        if (particpent_id == getPArticipentId) {

                            const currentDate = new Date(); // Current date
                            //const couponExpireDate = "2024-05-28"; // Coupon expiry date
                            // Convert current date to the format "YYYY-MM-DD"
                            const currentYear = currentDate.getFullYear();
                            const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0'); // Add leading zero if needed
                            const currentDay = String(currentDate.getDate()).padStart(2, '0'); // Add leading zero if needed
                            const currentFormattedDate = `${currentYear}-${currentMonth}-${currentDay}`;
                            const isTimePassedExpired = matchingCoupon.coupon_expire_date <= currentFormattedDate;
                            if (isTimePassedExpired) {
                                const messageUsedCoupon = 'The Coupon is Expired';
                                setUsedCouponMessage(prevMessages => ({ ...prevMessages, [workshop.id]: messageUsedCoupon }));
                            }
                            else {
                                discount = (singleWorkshopAmount * matchingCoupon.coupon_amout_value) / 100;
                            }

                        }
                        else if (useCoupon.length > 0) {
                            const messageUsedCoupon = 'The Coupon is Already used';
                            setUsedCouponMessage(prevMessages => ({ ...prevMessages, [workshop.id]: messageUsedCoupon }));
                        }
                    }
                    else {

                        const currentDate = new Date(); // Current date
                        //const couponExpireDate = "2024-05-28"; // Coupon expiry date
                        // Convert current date to the format "YYYY-MM-DD"
                        const currentYear = currentDate.getFullYear();
                        const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0'); // Add leading zero if needed
                        const currentDay = String(currentDate.getDate()).padStart(2, '0'); // Add leading zero if needed
                        const currentFormattedDate = `${currentYear}-${currentMonth}-${currentDay}`;
                        const isTimePassedExpired = matchingCoupon.coupon_expire_date <= currentFormattedDate;
                        if (isTimePassedExpired) {
                            const messageUsedCoupon = 'The Coupon is Expired';
                            setUsedCouponMessage(prevMessages => ({ ...prevMessages, [workshop.id]: messageUsedCoupon }));
                        }
                        else {
                            discount = (singleWorkshopAmount * matchingCoupon.coupon_amout_value) / 100;
                        }


                    }
                }
                else if (matchingCoupon.coupon_amout_type === "fixed" && workshop.id === matchingCoupon.conference_id
                    &&
                    inputValues[workshop.id] === matchingCoupon.coupon_code) {
                    if (useCouponCheck) {
                        const particpent_id = id;
                        const getPArticipentId = useCouponCheck.participant_id
                        if (particpent_id == getPArticipentId) {

                            const currentDate = new Date(); // Current date
                            //const couponExpireDate = "2024-05-28"; // Coupon expiry date
                            // Convert current date to the format "YYYY-MM-DD"
                            const currentYear = currentDate.getFullYear();
                            const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0'); // Add leading zero if needed
                            const currentDay = String(currentDate.getDate()).padStart(2, '0'); // Add leading zero if needed
                            const currentFormattedDate = `${currentYear}-${currentMonth}-${currentDay}`;
                            const isTimePassedExpired = matchingCoupon.coupon_expire_date <= currentFormattedDate;
                            if (isTimePassedExpired) {
                                const messageUsedCoupon = 'The Coupon is Expired';
                                setUsedCouponMessage(prevMessages => ({ ...prevMessages, [workshop.id]: messageUsedCoupon }));
                            }
                            else {
                                const currentDate = new Date(); // Current date
                                //const couponExpireDate = "2024-05-28"; // Coupon expiry date
                                // Convert current date to the format "YYYY-MM-DD"
                                const currentYear = currentDate.getFullYear();
                                const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0'); // Add leading zero if needed
                                const currentDay = String(currentDate.getDate()).padStart(2, '0'); // Add leading zero if needed
                                const currentFormattedDate = `${currentYear}-${currentMonth}-${currentDay}`;
                                const isTimePassedExpired = matchingCoupon.coupon_expire_date <= currentFormattedDate;
                                if (isTimePassedExpired) {
                                    const messageUsedCoupon = 'The Coupon is Expired';
                                    setUsedCouponMessage(prevMessages => ({ ...prevMessages, [workshop.id]: messageUsedCoupon }));
                                }
                                else {
                                    discount = matchingCoupon.coupon_amout_value;
                                }

                            }

                        }
                        else if (useCoupon && useCoupon.length > 0) {
                            const messageUsedCoupon = 'The Coupon is Already used';
                            setUsedCouponMessage(prevMessages => ({ ...prevMessages, [workshop.id]: messageUsedCoupon }));

                        }
                    }
                    else {
                        const currentDate = new Date(); // Current date
                        //const couponExpireDate = "2024-05-28"; // Coupon expiry date
                        // Convert current date to the format "YYYY-MM-DD"
                        const currentYear = currentDate.getFullYear();
                        const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0'); // Add leading zero if needed
                        const currentDay = String(currentDate.getDate()).padStart(2, '0'); // Add leading zero if needed
                        const currentFormattedDate = `${currentYear}-${currentMonth}-${currentDay}`;
                        const isTimePassedExpired = matchingCoupon.coupon_expire_date <= currentFormattedDate;
                        if (isTimePassedExpired) {
                            const messageUsedCoupon = 'The Coupon is Expired';
                            setUsedCouponMessage(prevMessages => ({ ...prevMessages, [workshop.id]: messageUsedCoupon }));
                        }
                        else {
                            discount = matchingCoupon.coupon_amout_value;
                        }
                    }
                }


                if (!isNaN(singleWorkshopAmount) && discount > 0) {

                    const message = `Discount applied for workshop ${workshop.id}. Coupon Code: ${inputValues[workshop.id]}`;
                    setDiscountMessages(prevMessages => ({ ...prevMessages, [workshop.id]: message }));
                    setDisabledInputs(prevDisabled => ({ ...prevDisabled, [workshop.id]: true }));

                }
            }

            return acc + (singleWorkshopAmount - discount);
        }, 0);

        setTotalAmount(newTotalAmount);
    }, [selectedWorkshopAmounts, couponCodes, inputValues]);





    const toggleCouponInput = (workshopId) => {
        setShowCouponInputs((prevState) => ({
            ...prevState,
            [workshopId]: !prevState[workshopId],
        }));
    };

    const handleInput = (e) => {
        const value = e.target.value;
        const inputName = e.target.name;
        setEditWorkShopParticpant({ ...editWorkShopParticpant, [e.target.name]: e.target.value });


    }

    const handleCountry = (e) => {
        const selectCountry = e.target.value;
        setCountry(selectCountry);
        localStorage.setItem('selectedCountry', selectCountry);
    }

    // const handleChange = (event) => {

    //     setGender(event.target.value);
    //     localStorage.setItem(event.target.value);
    // };
    const handleChange = (event) => {
        setGender(event.target.value);

    };

    // Function to handle radio button change


    const handleNameTitle = (e) => {
        const selectNametitle = e.target.value;

        setNameTitle(selectNametitle);
        localStorage.setItem('nameTitle', selectNametitle)
    }

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleInputChange = (fieldName, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: value,
        }));
    };




    const { error_list } = addWorkShopParticpant;
    const handleSubmitBank = (e) => {
        e.preventDefault();
        setLoading(true); // Set loading state to true when button is clicked
        const paymentBank = "paymentBank";
        const data = {
            partiticipant_id: id,
            eventid,
            name_title: nameTitle,
            participant_saudi_council_no: editWorkShopParticpant.participant_saudi_council_no,
            participant_name: editWorkShopParticpant.participant_name,
            participant_email: editWorkShopParticpant.participant_email,
            participant_conference_category: singleWorkShopCategory.id,
            participant_contact: editWorkShopParticpant.participant_phone_number,
            participant_profession: editWorkShopParticpant.participant_profession,
            participant_gender: gender,
            participant_country: country,
            participant_city: editWorkShopParticpant.participant_city,
            selectedWorkshopAmounts,
            participant_cooupons: inputValues,
            totalAmount,
            //paymentBank,
            //editWorkShopParticpantWorkshops


        };



        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            axios.post(`/api/conference-particpant-update/${id}`, data, config).then(res => {
                setLoading(false);
                if (res.data.status === 200) {


                    swal('Success', res.data.message, 'success');
                    history.goBack();
                    // history.push('/workshop/particpant-form/thank-you');
                    //history.push(`/workshop/thank-you/${id}`);
                    return false;
                }
                else {

                    setAddWorkShopParticpant({ ...addWorkShopParticpant, error_list: res.data.validate_error })

                }

            }).catch(error => {
                setLoading(false); // Set loading state back to false in case of error
                console.error('Error:', error);
            });
        }).catch(error => {
            setLoading(false); // Set loading state back to false in case of error
            console.error('Error:', error);
        });
    };







    //Check Out
    const renderSelectedWorkshopInfo = () => {


        const handleRemoveWorkshop = (conferenceIdToRemove) => {
            alert(conferenceIdToRemove)

            // Filter out the workshop to remove from the state
            const updatedWorkshops = selectedWorkshopAmounts.filter(conference => conference.id !== conferenceIdToRemove);
            // Update the state with the filtered array
            //console.log(updatedWorkshops)
            setSelectedWorkshopAmounts(updatedWorkshops);
        };
        return (
            <div>

                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Conference Name</TableCell>
                                <TableCell>Conference Day</TableCell>
                                <TableCell>Used Coupons</TableCell>
                                <TableCell align="center">Coupon Input</TableCell>
                                <TableCell align="right">Conference Amount</TableCell>
                                <TableCell align="right">Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {selectedWorkshopAmounts && selectedWorkshopAmounts.map((selectedWorkshop) => {
                                const participant_id = id;
                                const workshopId = selectedWorkshop.id;

                                const hasCoupon = workshopUsedCoupeon.some(
                                    (couponsVal) => Number(selectedWorkshop.id) === Number(couponsVal.conference_id)
                                );

                                const foundCoupon = workshopUsedCoupeon.find(
                                    (couponsVal) =>
                                        Number(participant_id) === Number(couponsVal.participant_id) &&
                                        Number(selectedWorkshop.id) === Number(couponsVal.conference_id)
                                );

                                const couponCode = hasCoupon ? (foundCoupon ? foundCoupon.coupon_code : '') : '';

                                return (
                                    <TableRow key={selectedWorkshop.id}>
                                        {/* Conference Category */}
                                        <TableCell>{selectedWorkshop.conference_name}</TableCell>
                                        <TableCell>{selectedWorkshop.conference_day}</TableCell>

                                        {/* Used Coupons */}
                                        {couponCode ? (
                                            <TableCell onClick={() => copyCoupon(couponCode)} style={{ cursor: 'pointer' }}>
                                                {couponCode}
                                                <span role="img" aria-label="copy" style={{ fontSize: '1rem', color: '#007bff', marginLeft: '10px' }}>
                                                    📋
                                                </span>
                                                {copiedStates[couponCode] && (
                                                    <span style={{ marginLeft: '10px', color: 'green', fontWeight: 'bold' }}>Copied!</span>
                                                )}
                                            </TableCell>
                                        ) : (
                                            <TableCell>No Coupon</TableCell>
                                        )}

                                        {/* Coupon Input */}
                                        <TableCell align="center">
                                            {selectedWorkshop.conference_coupon === 1 && (
                                                <>
                                                    <Checkbox
                                                        checked={!!showCouponInputs[selectedWorkshop.id]}
                                                        onChange={() => toggleCouponInput(selectedWorkshop.id)}
                                                    />
                                                    {showCouponInputs[selectedWorkshop.id] && (
                                                        <div style={{ marginTop: '10px' }}>
                                                            <Input
                                                                type="text"
                                                                placeholder="Enter Coupon Code"
                                                                value={inputValues[selectedWorkshop.id] || ''}
                                                                onChange={(e) => handleCouponCodeChange(selectedWorkshop.id, e.target.value)}
                                                            />
                                                            {discountMessages[selectedWorkshop.id] && (
                                                                <div style={{ color: 'green', fontWeight: 'bold', marginTop: '5px' }}>
                                                                    Coupon Applied
                                                                </div>
                                                            )}
                                                            {!discountMessages[selectedWorkshop.id] &&
                                                                usedCouponMessage[selectedWorkshop.id] && (
                                                                    <div style={{ color: 'red', fontWeight: 'bold', marginTop: '5px' }}>
                                                                        {usedCouponMessage[selectedWorkshop.id]}
                                                                    </div>
                                                                )}
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </TableCell>

                                        {/* Conference Amount */}
                                        <TableCell align="right">{selectedWorkshop.conference_amount}</TableCell>

                                        {/* Action */}
                                        <TableCell align="right">
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                onClick={() => handleRemoveWorkshop(selectedWorkshop.id)}
                                            >
                                                Remove
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}

                            {/* Total Amount Row */}
                            <TableRow>
                                <TableCell colSpan={5} align="right" style={{ fontWeight: 'bold', fontSize: '1rem' }}>
                                    Total Amount: {totalAmount}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>


                </TableContainer>

                <Box noValidate sx={{ display: 'flex', justifyContent: 'flex-end', flexWrap: 'wrap' }}>

                    {/* {
                        totalAmount > 0 ?
                            abstractHomeSetup.online_status == 1 && (
                                <Button
                                    onClick={handleSubmitOnline}
                                    variant="contained"
                                    sx={{
                                        mt: 3,
                                        mb: 2,
                                        ml: 4,
                                        mr: 2,
                                        backgroundColor: abstractHomeSetup.color_code_two
                                            ? abstractHomeSetup.color_code_two
                                            : gradientBackground,
                                        cursor: loading ? 'not-allowed' : 'pointer', // Disable pointer events when loading
                                        opacity: loading ? 0.6 : 1, // Reduce opacity when loading
                                    }}
                                    disabled={loading} // Disable the button when loading
                                >
                                    {loading ? 'Loading...' : 'Online'}
                                </Button>

                            ) : ""} */}
                            
                           
                                <Button
                                    onClick={handleSubmitBank}
                                    variant="contained"
                                    sx={{
                                        mt: 3, mb: 2, mr: 2, backgroundColor: abstractHomeSetup.color_code_two
                                            ? abstractHomeSetup.color_code_two
                                            : gradientBackground,
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? 'Loading...' : 'Update'}
                                </Button>
                           
                    {/* {
                        totalAmount > 0 ?
                            abstractHomeSetup.bank_status == 1 && (
                                <Button
                                    onClick={handleSubmitBank}
                                    variant="contained"
                                    sx={{
                                        mt: 3, mb: 2, mr: 2, backgroundColor: abstractHomeSetup.color_code_two
                                            ? abstractHomeSetup.color_code_two
                                            : gradientBackground,
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? 'Loading...' : 'Bank'}
                                </Button>
                            ) : ""} */}

                    {/* {
                        totalAmount > 0 ?
                            abstractHomeSetup.cash_status == 1 && (


                                <Button
                                    onClick={handleSubmitCash}
                                    variant="contained"
                                    sx={{
                                        mt: 3, mb: 2, mr: 2, backgroundColor: abstractHomeSetup.color_code_two
                                            ? abstractHomeSetup.color_code_two
                                            : gradientBackground,
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? 'Loading...' : 'Cash'}
                                </Button>
                            ) : ""} */}

                    {/* {

                        abstractHomeSetup.free_status == 1 && (
                            <Button
                                onClick={handleSubmitFree}
                                variant="contained"
                                sx={{
                                    mt: 3, mb: 2, backgroundColor: abstractHomeSetup.color_code_two
                                        ? abstractHomeSetup.color_code_two
                                        : gradientBackground,
                                }}
                                disabled={loading}
                            >
                                {loading ? 'Loading...' : 'Free'}
                            </Button>
                        )} */}

                </Box>

            </div>
        );
    };

    return (
        <div>
            <Grid container justifyContent="center" marginTop="80px">
                <Grid item xs={12} >
                    <Typography
                        component="h1"
                        variant="h5"
                        sx={{
                            textAlign: 'center', // Center the text
                        }}>
                        Conference Participant Details
                    </Typography>

                    <Grid item xs={12}>
                        <Stepper activeStep={activeStep} alternativeLabel>
                            {steps.map((label) => (
                                <Step key={label}>
                                    <StepLabel>{label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    </Grid>
                    <div>
                        {activeStep === steps.length ? (
                            <div >

                                <div style={{ margin: '1%', width: '60vw', marginLeft: '15%' }}>
                                    <Box sx={{ color: '#000000', }} >
                                        {error_list && Object.keys(error_list).map(fieldName => (
                                            <div key={fieldName}>
                                                {/* <span style={{ color: 'red' }}>{fieldName}: </span> */}
                                                {error_list[fieldName].map((error, index) => (
                                                    <span key={index} style={{ color: 'red' }}>{error}</span>
                                                ))}
                                            </div>
                                        ))}


                                        <Card sx={cardStyles}  >
                                            <CardContent >
                                                <Typography component="h1" variant="h5" sx={{
                                                    textAlign: 'center', // Center the text
                                                }}>
                                                    Check Out

                                                </Typography>
                                                <Box component="form" noValidate sx={{ mt: 3 }}>

                                                    {renderSelectedWorkshopInfo()}


                                                </Box>
                                                <Grid container justifyContent="space-between">
                                                    <Button
                                                        //disabled={activeStep === 0}
                                                        disabled={true}
                                                        onClick={handleBack}
                                                        sx={{
                                                            mt: 5, backgroundColor: abstractHomeSetup.color_code_two
                                                                ? abstractHomeSetup.color_code_two
                                                                : gradientBackground,
                                                        }}>
                                                        Back
                                                    </Button>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        // onClick={handleNext}
                                                        onClick={handleBack}
                                                        sx={{
                                                            mt: 5, backgroundColor: abstractHomeSetup.color_code_two
                                                                ? abstractHomeSetup.color_code_two
                                                                : gradientBackground,
                                                        }}
                                                    >
                                                        {activeStep === steps.length - 1 ? 'Back' : 'BAck'}
                                                    </Button>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Box>
                                </div>
                            </div>
                        ) : (
                            <div>
                                {/* <Typography>{steps[activeStep]}</Typography> */}
                                {/* Render your form for each step */}
                                {activeStep === 0 && (
                                    <div style={{ margin: '1%', width: '60vw', marginLeft: '15%' }}>
                                        <Box sx={{ color: '#000000', }} >
                                            <h4 sx={{ m: 2, color: '#000000' }} >

                                                <Button sx={{
                                                    float: 'right',
                                                    marginTop: '2%',
                                                    backgroundColor: abstractHomeSetup.color_code_two
                                                        ? abstractHomeSetup.color_code_two
                                                        : gradientBackground,
                                                    ":hover": {
                                                        color: "white"
                                                    },
                                                }}
                                                    color='success'
                                                    size='small'
                                                    variant='contained'
                                                    onClick={() => history.goBack()} // Use the Link component here
                                                     >
                                                    Back
                                                </Button>
                                            </h4>
                                            <Card sx={cardStyles}  >
                                                <CardContent >

                                                    <Box component="form" noValidate sx={{ mt: 3 }}>
                                                        <Grid container spacing={4}>

                                                            <Grid item xs={12} lg={6} sm={12}>
                                                                <FormControl fullWidth>
                                                                    <InputLabel id="demo-simple-select-label">Title</InputLabel>
                                                                    <Select
                                                                        value={nameTitle}
                                                                        onChange={handleNameTitle}
                                                                        labelId="demo-simple-select-label"
                                                                        id="demo-simple-select"
                                                                        label="Action"
                                                                    >
                                                                        <MenuItem value={'Mr'}>Mr</MenuItem>
                                                                        <MenuItem value={'Mrs'}>Mrs</MenuItem>
                                                                        <MenuItem value={'Ms'}>Ms</MenuItem>
                                                                        <MenuItem value={'Dr'}>Dr</MenuItem>
                                                                        <MenuItem value={'Prof'}>Prof</MenuItem>
                                                                        <MenuItem value={'Eng'}>Eng</MenuItem>
                                                                        <MenuItem value={'Sheikh'}>Sheikh</MenuItem>
                                                                    </Select>
                                                                    <FormHelperText>{addWorkShopParticpant.error_list.name_title}</FormHelperText>
                                                                </FormControl>
                                                            </Grid>


                                                            <Grid item xs={12} lg={6} sm={12}>
                                                                <TextField
                                                                    autoComplete="given-name"
                                                                    required
                                                                    fullWidth
                                                                    label="Full Name"
                                                                    autoFocus
                                                                    name='participant_name' onChange={handleInput}
                                                                    value={editWorkShopParticpant?.participant_name || ""}
                                                                    helperText={addWorkShopParticpant?.error_list.participant_name} />
                                                            </Grid>
                                                            <Grid item xs={12} lg={6} sm={12}>
                                                                <TextField
                                                                    required
                                                                    fullWidth
                                                                    label="Saudi Council No"
                                                                    type="text"
                                                                    name='participant_saudi_council_no'
                                                                    onChange={handleInput}
                                                                    value={editWorkShopParticpant?.participant_saudi_council_no || ""}
                                                                    helperText={editWorkShopParticpant?.error_list?.participant_saudi_council_no || ""}
                                                                />
                                                                <span style={{ color: 'red', textAlign: 'center' }}>
                                                                    If you don't have, just type 0000
                                                                </span>
                                                            </Grid>

                                                            <Grid item xs={12} lg={6} sm={12}>
                                                                <FormControl fullWidth>
                                                                    <InputLabel id="demo-simple-select-label">Conference Category</InputLabel>
                                                                    <Select

                                                                        value={editWorkShopParticpant?.conference_category_id || ""}
                                                                        // onChange={handleWorkShopCategory}
                                                                        onChange={handleregistration}
                                                                        labelId="demo-simple-select-label"
                                                                        id="demo-simple-select"
                                                                        label="Conference Category" >
                                                                        {
                                                                            workshopCategoryData && workshopCategoryData.map((val, index) => {
                                                                                return (
                                                                                    <MenuItem value={val.id} key={val.id}>{val.conference_category_title} </MenuItem>
                                                                                )
                                                                            })
                                                                        }



                                                                    </Select>

                                                                    <FormHelperText>{addWorkShopParticpant.error_list.participant_workshop_categoy}</FormHelperText>
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xs={12} lg={6} sm={12}>
                                                                <TextField
                                                                    required
                                                                    fullWidth
                                                                    id="email"
                                                                    label="Email Address"
                                                                    autoComplete="participant_email"
                                                                    name='participant_email'
                                                                    onChange={handleInput}
                                                                    value={editWorkShopParticpant?.participant_email || ""}
                                                                    helperText={editWorkShopParticpant?.error_list?.participant_email || ""}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} lg={6} sm={12}>
                                                                <TextField
                                                                    required
                                                                    fullWidth
                                                                    label="Contact Number"
                                                                    type="text"
                                                                    name='participant_phone_number'
                                                                    onChange={handleInput}
                                                                    value={editWorkShopParticpant?.participant_phone_number || ""}
                                                                    helperText={editWorkShopParticpant?.error_list?.participant_phone_number || ""}
                                                                />
                                                                {/* <span style={{ color: 'red', textAlign: 'center' }}>
                                                                If you don't have, just type 0000
                                                            </span> */}
                                                            </Grid>



                                                            <Grid item xs={12} lg={6} sm={12}>
                                                                <TextField
                                                                    autoComplete="given-name"
                                                                    required
                                                                    fullWidth

                                                                    label="Profession"
                                                                    autoFocus
                                                                    name='participant_profession'
                                                                    onChange={handleInput} value={editWorkShopParticpant?.participant_profession || ""}
                                                                    helperText={editWorkShopParticpant?.error_list?.participant_profession} />
                                                            </Grid>
                                                            <Grid item xs={12} lg={6} sm={12}>
                                                                <FormControl>
                                                                    <FormLabel id="demo-row-radio-buttons-group-label">Gender</FormLabel>
                                                                    <RadioGroup
                                                                        row
                                                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                                                        name="row-radio-buttons-group"
                                                                        value={gender.toString()}  // Convert the numeric value to a string
                                                                        onChange={handleChange}
                                                                    >
                                                                        <FormControlLabel value="0" control={<Radio />} label="Male" />
                                                                        <FormControlLabel value="1" control={<Radio />} label="Female" />
                                                                    </RadioGroup>
                                                                    <FormHelperText>{addWorkShopParticpant.error_list.participant_gender}</FormHelperText>
                                                                </FormControl>
                                                            </Grid>


                                                            <Grid item xs={12} lg={6} sm={12}>
                                                                <FormControl fullWidth>
                                                                    <InputLabel id="demo-simple-select-label">Country</InputLabel>
                                                                    <Select
                                                                        value={country || ""}
                                                                        onChange={handleCountry}
                                                                        labelId="demo-simple-select-label"
                                                                        id="demo-simple-select"
                                                                        label="Action" >
                                                                        <MenuItem value={'Saudi Arabia'}>Saudi Arabia</MenuItem>
                                                                        <MenuItem value={'UAE'}>UAE</MenuItem>
                                                                        <MenuItem value={'Qatar'}> Qatar</MenuItem>
                                                                        <MenuItem value={'Oman'}>Oman </MenuItem>
                                                                        <MenuItem value={'Jordan'}>Jordan</MenuItem>
                                                                        <MenuItem value={'Trurky'}>Trurky </MenuItem>

                                                                    </Select>
                                                                    <FormHelperText></FormHelperText>
                                                                </FormControl>
                                                            </Grid>

                                                            <Grid item xs={12} lg={6} sm={12} >
                                                                <TextField
                                                                    autoComplete="given-name"
                                                                    required
                                                                    fullWidth
                                                                    label="City"
                                                                    autoFocus
                                                                    name='participant_city' onChange={handleInput} value={editWorkShopParticpant?.participant_city || ""} />
                                                            </Grid>
                                                        </Grid>


                                                        <Grid container justifyContent="space-between">
                                                            <Button
                                                                disabled={activeStep === 0}
                                                                onClick={handleBack}
                                                                sx={{ mt: 5 }}>
                                                                Back
                                                            </Button>
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                onClick={handleNext}
                                                                sx={{
                                                                    mt: 5, backgroundColor: abstractHomeSetup.color_code_two
                                                                        ? abstractHomeSetup.color_code_two
                                                                        : gradientBackground,
                                                                }}
                                                            >
                                                                {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                                                            </Button>
                                                        </Grid>

                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        </Box>
                                    </div>

                                )}
                                {activeStep === 1 && (
                                    <div style={{ margin: '1%', width: '60vw', marginLeft: '15%' }}>
                                        <Box sx={{ color: '#000000', mt: '5%' }}>
                                            <Card sx={cardStyles}>
                                                <CardContent>
                                                    <Typography component="h1" variant="h5" sx={{ textAlign: 'center' }}>
                                                        Conference Registration
                                                    </Typography>
                                                    <Box component="form" noValidate sx={{ mt: 3 }}>
                                                        <Grid container spacing={4}>
                                                            <Grid item xs={12} sm={6} md={4} lg={6}>
                                                                <Box display="flex" alignItems="center">
                                                                    <FormControlLabel
                                                                        control={
                                                                            <Checkbox
                                                                                color="success"
                                                                                checked={singleWorkShopCategory.conference_category_title !== null}
                                                                            />
                                                                        }
                                                                        label="Conference Registration"
                                                                        name="permissions"
                                                                    />
                                                                </Box>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid container justifyContent="space-between">
                                                            <Button
                                                                disabled={activeStep === 0}
                                                                onClick={handleBack}
                                                                sx={{
                                                                    mt: 5, backgroundColor: abstractHomeSetup.color_code_two
                                                                        ? abstractHomeSetup.color_code_two
                                                                        : gradientBackground,
                                                                }}
                                                            >
                                                                Back
                                                            </Button>
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                onClick={handleNext}
                                                                sx={{
                                                                    mt: 5, backgroundColor: abstractHomeSetup.color_code_two
                                                                        ? abstractHomeSetup.color_code_two
                                                                        : gradientBackground,
                                                                }}
                                                            >
                                                                {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                                                            </Button>
                                                        </Grid>
                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        </Box>
                                    </div>
                                )}
                                {activeStep === 2 && (
                                    <div style={{ margin: '1%', width: '100%', marginLeft: '5%' }}>
                                        <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>

                                            <Card sx={{ width: '100%', float: 'center' }} >
                                                <CardContent >
                                                    <Typography component="h1" variant="h5" sx={{
                                                        textAlign: 'center', // Center the text
                                                    }}>
                                                        Registration Fees
                                                    </Typography>
                                                    <br></br>
                                                    <Typography
                                                        component="h6"
                                                        variant="h5"
                                                        sx={{
                                                            textAlign: 'center', // Center the text
                                                            color: 'red', // Set the text color to red
                                                        }} >
                                                        {addWorkShopParticpant.error_list.selectedWorkshopAmounts}
                                                    </Typography>


                                                    <Box component="form" noValidate sx={{ mt: 3 }}>
                                                        <Grid container spacing={4}>

                                                            <Grid item xs={6} >

                                                            </Grid>

                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <FormControlLabel
                                                                control={<Checkbox color="success" checked={singleWorkShopCategory.workshop_category_title !== null} />}
                                                                label={
                                                                    <span
                                                                        sx={{
                                                                            margin: '55px',
                                                                            display: 'inline-block',
                                                                        }}
                                                                    >
                                                                        {singleWorkShopCategory.workshop_category_title}
                                                                    </span>
                                                                }
                                                                color="success"
                                                                name="permissions"
                                                            />

                                                            <TableContainer component={Paper}>
                                                                <Table>
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <TableCell>ID</TableCell>
                                                                            <TableCell>Conference Name</TableCell>
                                                                            <TableCell>Conference Day</TableCell>
                                                                            <TableCell>Conference Date</TableCell>
                                                                            <TableCell>Conference End Date</TableCell>
                                                                            <TableCell>Conference Start Time</TableCell>
                                                                            <TableCell>Conference End Time</TableCell>
                                                                            <TableCell>Price</TableCell>
                                                                            <TableCell>Select</TableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>

                                                                        {singleWorkShopCategory.conferences &&
                                                                            singleWorkShopCategory.conferences.map((row, i) => {
                                                                                const { isDisabled, color } = isCheckboxDisabled(row);

                                                                                const paidWorkshops = updateWorkShopParticpantWorkshops && updateWorkShopParticpantWorkshops.some((alreadySelected) =>
                                                                                    alreadySelected.id = row.id
                                                                                    &&
                                                                                    alreadySelected.conference_date === row.conference_date
                                                                                    &&
                                                                                    alreadySelected.conference_day === row.conference_day
                                                                                    &&
                                                                                    alreadySelected.payment_status === 1
                                                                                    &&
                                                                                    alreadySelected.conference_start_time === row.conference_start_time &&

                                                                                    //alreadySelected.payment_status ===  1 &&
                                                                                    alreadySelected.conference_end_time === row.conference_end_time)


                                                                                const notPaidWorkshops = updateWorkShopParticpantWorkshops && updateWorkShopParticpantWorkshops.filter(workshop =>
                                                                                    workshop.conference_id === false && workshop.payment_status === 0

                                                                                );
                                                                                return (
                                                                                    <TableRow
                                                                                        key={row.id}
                                                                                        style={{
                                                                                            backgroundColor: isCheckboxDisabled(row).color,
                                                                                            ...(paidWorkshops && { backgroundColor: '#4caf50', color: 'white !important' })
                                                                                        }}
                                                                                    >
                                                                                        <TableCell>{i + 1}</TableCell>
                                                                                        <TableCell>{row.conference_name}</TableCell>
                                                                                        <TableCell>{row.conference_day}</TableCell>
                                                                                        <TableCell>{row.conference_date}</TableCell>
                                                                                        <TableCell>{row.conference_end_date}</TableCell>
                                                                                        <TableCell>{row.conference_start_time}</TableCell>
                                                                                        <TableCell>{row.conference_end_time}</TableCell>
                                                                                        <TableCell>{row.conference_amount}</TableCell>
                                                                                        <TableCell>
                                                                                            {
                                                                                                paidWorkshops ? (
                                                                                                    <Checkbox
                                                                                                        {...label}
                                                                                                        disabled
                                                                                                        sx={{
                                                                                                            color: pink[800],
                                                                                                            '&.Mui-checked': {
                                                                                                                color: pink[600],
                                                                                                            },
                                                                                                        }}
                                                                                                    />
                                                                                                ) : (
                                                                                                    notPaidWorkshops.some(workshop => workshop.conference_day === row.conference_day) ? (

                                                                                                        <Checkbox
                                                                                                            checked={editWorkShopParticpantWorkshops.some((selectedWorkshop) => selectedWorkshop.conference_id === row.id)}
                                                                                                            onChange={(e) => handleCheckboxChange(e, row, row.conference_amount)}
                                                                                                        //disabled={isCheckboxDisabled(row).isDisabled}
                                                                                                        //style={{ color: 'black', backgroundColor: 'yellow' }}
                                                                                                        />
                                                                                                    ) : (
                                                                                                        <Checkbox
                                                                                                            checked={editWorkShopParticpantWorkshops.some((selectedWorkshop) => selectedWorkshop.conference_id === row.id)}
                                                                                                            onChange={(e) => handleCheckboxChange(e, row, row.conference_amount)}
                                                                                                            disabled={isCheckboxDisabled(row).isDisabled}
                                                                                                        />
                                                                                                    )


                                                                                                )


                                                                                            }
                                                                                            <br></br>
                                                                                            <br></br>
                                                                                            {isCheckboxDisabled(row).seatLimitMessage && (
                                                                                                <span style={{ color: 'red' }}>
                                                                                                    {isCheckboxDisabled(row).seatLimitMessage}
                                                                                                </span>
                                                                                            )}

                                                                                            {isCheckboxDisabled(row).timeOffMessage && (
                                                                                                <span style={{ color: 'orange' }}>
                                                                                                    {isCheckboxDisabled(row).timeOffMessage}
                                                                                                </span>
                                                                                            )}

                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                );
                                                                            })}
                                                                    </TableBody>
                                                                </Table>
                                                            </TableContainer>
                                                        </Grid>
                                                        <Grid container justifyContent="space-between">
                                                            <Button

                                                                disabled={activeStep === 0}
                                                                onClick={handleBack}
                                                                sx={{ mt: 5 }}>
                                                                Back
                                                            </Button>
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                onClick={handleNext}
                                                                sx={{
                                                                    mt: 5, backgroundColor: abstractHomeSetup.color_code_two
                                                                        ? abstractHomeSetup.color_code_two
                                                                        : gradientBackground,
                                                                }}
                                                            >
                                                                {activeStep === steps.length - 1 ? 'Submit' : 'Next'}
                                                            </Button>
                                                        </Grid>

                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        </Box>
                                    </div>
                                )}



                            </div>
                        )}
                    </div>
                </Grid>
            </Grid>







        </div>
    );
}

export default EditConferenceParticpant;
